import { Country } from '@prisma/client';
import { FeatureLaunch } from '../featureLaunchEnum';

export enum CurrentLaunchStage {
  DEV = 'DEV',
  STAGING = 'STAGING',
  DEMO = 'DEMO',
  PROD = 'PROD',
}

export const LaunchStages: Record<FeatureLaunch, CurrentLaunchStage> = {
  FILING_AUTOMATION_DEMO: CurrentLaunchStage.DEMO,
  COMPLIANCE_MONITOR: CurrentLaunchStage.PROD,
  MARKETPLACE_TAB: CurrentLaunchStage.PROD,
  US_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  CA_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  IN_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  GB_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  SG_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  AE_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  UPSELLS: CurrentLaunchStage.PROD,
  SETTINGS: CurrentLaunchStage.PROD,
  IN_LLP_FORM: CurrentLaunchStage.PROD,
  SINGAPORE_INCORPORATION: CurrentLaunchStage.PROD,
  US_INCORPORATION: CurrentLaunchStage.PROD,
  INDIA_INCORPORATION: CurrentLaunchStage.PROD,
  UNITED_KINGDOM_INCORPORATION: CurrentLaunchStage.PROD,
  BOOKKEEPING: CurrentLaunchStage.PROD,
  ENTERPRISE_APP_SALES_TAX: CurrentLaunchStage.PROD,
  SALES_TAX_ROOTFI_INTEGRATION: CurrentLaunchStage.PROD,
  SALES_TAX_ROOTFI_BILLS_SYNC: CurrentLaunchStage.STAGING,
  SALES_TAX_EXEMPTIONS_TAB: CurrentLaunchStage.PROD,
  US_INCORPORATION_CORPORATE_STAKEHOLDERS: CurrentLaunchStage.PROD,
  ADMIN_AGENT_FIRMS_TAB: CurrentLaunchStage.PROD,
  GET_HELP_BUTTON: CurrentLaunchStage.PROD,
  IE_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  NL_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  ES_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  IT_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  FR_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  LU_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  BG_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  PH_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  CH_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  VG_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  MA_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  BE_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  MX_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  BR_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  CL_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  CO_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  AR_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  UY_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  SE_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  PT_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  JP_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  ZA_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  FJ_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  CK_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  ID_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  KR_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  SA_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  SALES_TAX_FILINGS: CurrentLaunchStage.PROD,
  REGISTRATION_AND_CREDENTIALS_TAB: CurrentLaunchStage.PROD,
  ADD_DOCUMENTS_BUTTON: CurrentLaunchStage.PROD,
  UG_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  KE_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  SK_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  SI_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  NO_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  RS_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  TR_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  PL_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  AU_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  DE_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  NZ_CORPORATION_ONBOARDING: CurrentLaunchStage.PROD,
  PREPAID_COMPLIANCE_BILLING: CurrentLaunchStage.PROD,
  TRANSFER_PRICING_BENCHMARKING: CurrentLaunchStage.PROD,
  MARKETPLACE_SERVICES_REVAMP: CurrentLaunchStage.DEMO,
  AFFILIATE_QUOTES_TAB: CurrentLaunchStage.PROD,
  CUSTOM_FILINGS: CurrentLaunchStage.PROD,
  SALES_TAX_TRANSACTIONS_DETAIL_PAGE: CurrentLaunchStage.PROD,
  AGENT_SECURE_INFORMATION_REQUEST: CurrentLaunchStage.PROD,
  THREADS_AND_COMMENTS: CurrentLaunchStage.PROD,
  THREAD_SUBSCRIPTIONS: CurrentLaunchStage.PROD,
  THREAD_FIRM_NAME_BADGE: CurrentLaunchStage.DEMO,
  SALES_TAX_CHAT: CurrentLaunchStage.PROD,
  SERVICE_REQUEST_NPS_SURVEY: CurrentLaunchStage.PROD,
  ENABLE_COUNTRIES_SELECTION_FOR_TAX_CALCULATION: CurrentLaunchStage.PROD,
  // Sales Tax Managed Registrations V2 - New onboarding tasks and simplified registration form
  SALES_TAX_MANAGED_REGISTRATIONS_V2: CurrentLaunchStage.PROD,
  // Agent client access - allows agents to log into client enterprise accounts
  AGENT_CLIENT_ACCESS: CurrentLaunchStage.PROD,
  // Backend guard changes (MAIN_APP_ADMIN on /user/me + /organizations) must be live
  // in an env before this flag reaches it — otherwise admins entering client view get
  // auto-signed-out by the enterprise app.
  ADMIN_CLIENT_ACCESS: CurrentLaunchStage.PROD,
  PRODUCT_CHANGELOG: CurrentLaunchStage.PROD,
  COMMENDA_OS_FORM_BUILDER: CurrentLaunchStage.PROD,

  TA_NEW_ONBOARDING: CurrentLaunchStage.PROD,

  GENERAL_THREAD: CurrentLaunchStage.PROD,

  DOCUMENTS_V2_DRIVE_VIEW: CurrentLaunchStage.PROD,
  // New accounting tab UI with rootfi integration (staging/dev only, prod shows old UI)
  SERVICE_REQUEST_SLA: CurrentLaunchStage.PROD,
  SLA_CATEGORY_EXPORT: CurrentLaunchStage.PROD,
  RESPONSE_TIME_SLA: CurrentLaunchStage.PROD,
  ACCOUNTING_TAB_REVAMP: CurrentLaunchStage.PROD,
  INDIRECT_TAX_UPLOAD_TRANSACTION_SERVICE_REQUEST: CurrentLaunchStage.PROD,
  AFFILIATE_TP_HARD_CODED_DEMO: CurrentLaunchStage.DEMO,
  AM_TP_DEMO: CurrentLaunchStage.DEMO,
  A_AND_M_TP_DEMO: CurrentLaunchStage.STAGING,
  TP_DOCUMENTATION_WORKFLOWS: CurrentLaunchStage.DEMO,
  // Tracks A_AND_M_TP_DEMO: the pickers only exist on the real affiliate chat. Do not promote past
  // an environment whose backend accepts `profile` on the conversation create.
  AFFILIATE_CHAT_PICKERS: CurrentLaunchStage.STAGING,
  TRANSFER_PRICING_DEMO: CurrentLaunchStage.PROD,
  TRANSFER_PRICING_SERVER_FILTERS: CurrentLaunchStage.DEV,
  TRANSFER_PRICING_DOCUMENTS: CurrentLaunchStage.PROD,
  TP_DOCUMENTS_PREVIEW_FEATURES: CurrentLaunchStage.DEMO,
  AFFILIATE_MARKETPLACE_SERVICES_TAB: CurrentLaunchStage.DEMO,
  WORKFLOW_BUILDER_ENTERPRISE_APP: CurrentLaunchStage.DEMO,
  INBOX_NAV: CurrentLaunchStage.PROD,
  CHAT_ROOM_PIN: CurrentLaunchStage.PROD,
  SALES_TAX_FILING_TAX_DETAILS: CurrentLaunchStage.DEV,
  ROOTFI_WORKFLOW_NODE: CurrentLaunchStage.STAGING,
  COMPLIANCE_CALENDAR_VIEW: CurrentLaunchStage.PROD,
  COMPLIANCE_EXTENSION: CurrentLaunchStage.PROD,
  HOME_CALENDAR_AGENDA: CurrentLaunchStage.PROD,
  OWNERSHIP_OVERHAUL: CurrentLaunchStage.PROD,
  COMPLIANCE_RULE_ENGINE: CurrentLaunchStage.PROD,
  WORKFLOW_RESET_TO_STEP_ACTION: CurrentLaunchStage.PROD,
  KEY_PERSONS: CurrentLaunchStage.PROD,
  COMMENDA_SERVICES_LAYER: CurrentLaunchStage.PROD,
  INDIRECT_TAX_TAX_CALCULATOR_BUTTON: CurrentLaunchStage.PROD,
  INDIRECT_TAX_LOCATIONS: CurrentLaunchStage.STAGING,
  INDIRECT_TAX_CA_CONTRIBUTIONS: CurrentLaunchStage.STAGING,
  INDIRECT_TAX_FILING_APPROVAL_REQUEST: CurrentLaunchStage.STAGING,
  INDIRECT_TAX_REGISTRATION_WORKFLOW: CurrentLaunchStage.PROD,
  MCP_CHAT_NAV: CurrentLaunchStage.PROD,
  CHAT_PANEL: CurrentLaunchStage.PROD,
  // Monitor tab (nav item + /regulatory-updates page). Held at DEMO so it shows on
  // dev, staging and demo but stays hidden on production.
  REGULATORY_UPDATES: CurrentLaunchStage.DEMO,
  SCHEDULED_AGENTS: CurrentLaunchStage.PROD,
  COMMENDA_MCP_ACCESS: CurrentLaunchStage.PROD,
  NEW_HOME_SCREEN: CurrentLaunchStage.PROD,
  COMMENDA_BILLING: CurrentLaunchStage.PROD,
  FORM_BUILDER_V2: CurrentLaunchStage.STAGING,
  NOTIFICATIONS_PLATFORM: CurrentLaunchStage.STAGING,
  BILLING_READ_FROM_MIRROR: CurrentLaunchStage.PROD,
  FORM_EXTERNAL_SHARE: CurrentLaunchStage.PROD,
  DOCUMENT_ASSEMBLER: CurrentLaunchStage.STAGING,
  ESIGN_AD_HOC_DOCUMENT: CurrentLaunchStage.STAGING,
  ENTITY_EXISTING_DOCUMENT_PICKER: CurrentLaunchStage.PROD,
  CHAT_FOLDER_UPLOAD: CurrentLaunchStage.PROD,
  CHAT_SAVE_GENERATED_FILES: CurrentLaunchStage.STAGING,
  AGENT_BULK_MESSAGING: CurrentLaunchStage.STAGING,
  SERVICE_AUDITOR: CurrentLaunchStage.STAGING,
  ADMIN_SERVICE_DELIVERY_SAVED_VIEWS: CurrentLaunchStage.STAGING,
  MANAGEMENT_REPORTING: CurrentLaunchStage.STAGING,
  MANAGEMENT_REPORT_COLUMN_LAYOUT: CurrentLaunchStage.STAGING,
  MANAGEMENT_REPORT_INLINE_OVERRIDE: CurrentLaunchStage.STAGING,
  SETTINGS_INTEGRATIONS_TAB: CurrentLaunchStage.PROD,
};

/**
 * We also need to track which compliance calendars we have released in different environments.
 */
export const ComplianceLaunchStages: Partial<
  Record<Country, CurrentLaunchStage>
> = {
  [Country.US]: CurrentLaunchStage.PROD,
  [Country.IN]: CurrentLaunchStage.PROD,
  [Country.GB]: CurrentLaunchStage.PROD,
  [Country.SG]: CurrentLaunchStage.PROD,
  [Country.AE]: CurrentLaunchStage.PROD,
  [Country.IE]: CurrentLaunchStage.PROD,
  [Country.NL]: CurrentLaunchStage.PROD,
  [Country.ES]: CurrentLaunchStage.PROD,
  [Country.IT]: CurrentLaunchStage.PROD,
  [Country.FR]: CurrentLaunchStage.PROD,
  [Country.LU]: CurrentLaunchStage.PROD,
  [Country.BG]: CurrentLaunchStage.PROD,
  [Country.PH]: CurrentLaunchStage.PROD,
  [Country.CH]: CurrentLaunchStage.PROD,
  [Country.VG]: CurrentLaunchStage.PROD,
  [Country.MA]: CurrentLaunchStage.PROD,
  [Country.BE]: CurrentLaunchStage.PROD,
  [Country.UG]: CurrentLaunchStage.PROD,
  [Country.KE]: CurrentLaunchStage.PROD,
  [Country.SK]: CurrentLaunchStage.PROD,
  [Country.SI]: CurrentLaunchStage.PROD,
  [Country.NO]: CurrentLaunchStage.PROD,
  [Country.RS]: CurrentLaunchStage.PROD,
  [Country.TR]: CurrentLaunchStage.PROD,
  [Country.PL]: CurrentLaunchStage.PROD,
  [Country.CA]: CurrentLaunchStage.PROD,
  [Country.AU]: CurrentLaunchStage.PROD,
  [Country.DE]: CurrentLaunchStage.PROD,
  [Country.NZ]: CurrentLaunchStage.PROD,
  [Country.EE]: CurrentLaunchStage.PROD,
  [Country.TH]: CurrentLaunchStage.PROD,
  [Country.AR]: CurrentLaunchStage.PROD,
  [Country.KR]: CurrentLaunchStage.PROD,
};

const CommendaProdCompanyId = 516;
const AllereProdCompanyId = 1465;
const OwnershipPilotCompanyId = 11642;

// Allows early release of features for specific companies, by ID.
// EX: lets us use a feature early as Commenda (with our real prod company data) before we release it globally.
export const EarlyProdReleaseCompanyIds: Partial<
  Record<FeatureLaunch, number[]>
> = {
  IN_CORPORATION_ONBOARDING: [CommendaProdCompanyId],
  // TEMPORARY: Allere early-release of Documents V2. Remove this entry once
  // DOCUMENTS_V2_DRIVE_VIEW is promoted to PROD launch stage.
  DOCUMENTS_V2_DRIVE_VIEW: [AllereProdCompanyId],
  OWNERSHIP_OVERHAUL: [OwnershipPilotCompanyId],
};

export const EarlyComplianceReleaseCompanyIds: Partial<
  Record<Country, number[]>
> = {};
